<template>
    <div class="row">
        <div class="col-md-12 pl-3 pr-3">
            <div class="row">
                <div :class="getSliderRowClass()" v-for="question in value.slider">
                    <div class="card h-100 query-result-container" v-bind:class="[getAlertIndicatorClass(question.alertActive)]">
                        <div class="d-flex justify-content-between">
                            <div class="my-auto p-2 hide-overflow">
                                {{question.title | languageString}}
                            </div>
                            <div class="my-auto pr-1">
                                <status-indicator :value="question.answer" :trend="question.trend" full-width :active="active"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div :class="getTextRowClass()" v-for="question in value.text">
                    <div class="card col-sm-12 h-100">
                        <div class="card-body">
                            <div class="col-sm-12">
                                <b>{{question.title | languageString}}</b>
                            </div>
                            <hr>
                            <div class="text">
                                <p v-if="question.answer" v-html="$options.filters.changeToBr(question.answer)"></p>
                                <p v-else><center>___</center></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import StatusIndicator from '../../Dashboard/Components/StatusIndicator'

  export default {
    name: 'BasicQueryResult',
    components: { StatusIndicator },
    props: {
      value: {
        type: Object
      },
      active: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      getSliderRowClass: function () {
        const length = this.value.slider.length
        let className = 'p-1 '

        if (length === 1) {
          className += 'col-lg-12 col-md-12 col-sm-12'
        } else if (length === 2) {
          className += 'col-lg-6 col-md-6 col-sm-6'
        } else if (length === 3) {
          className += 'col-lg-4 col-md-6 col-sm-6'
        } else if (length >= 4) {
          className += 'col-lg-3 col-md-6 col-sm-6'
        }
        return className
      },
      getTextRowClass: function () {
        const length = this.value.text.length
        let className = 'p-1 '

        if (length === 1) {
          className += 'col-xl-12 col-lg-12 col-md-12 col-sm-12'
        } else if (length === 2) {
          className += 'col-xl-6 col-lg-6 col-md-12 col-sm-12'
        } else if (length === 3) {
          className += 'col-xl-6 col-lg-6 col-md-12 col-sm-12'
        } else if (length >= 4) {
          className += 'col-xl-6 col-lg-6 col-md-12 col-sm-12'
        }
        return className
      },
      getAlertIndicatorClass: function (alertValue) {
        if (alertValue !== 0 &&
          !(this.$auth.user.isOwner || this.$auth.user.isLeader)) {
            return ''
          }

        if (alertValue < 0) {
          return 'pulse-red'
        } else if (alertValue > 0) {
          return 'pulse-green'
        } else {
          return ''
        }
      }
    }
  }
</script>

<style lang="scss">
    .result-inline {
        display: inline-block;
    }
    .h-100 {
        height: 100%;
    }
    .query-result-container {
        display: flex;
        justify-content: center;
    }
    .hide-overflow {
      overflow: hidden;
    }

    .pulse-red {
  box-shadow: 0 0 0 rgba(255,0,0, 0.4);
  animation: pulse-red 3s infinite;

  @-webkit-keyframes pulse-red {
    0% {
      -webkit-box-shadow: 0 0 0 2px rgba(255,0,0, 0.8);
    }
    50% {
        -webkit-box-shadow: 0 0 0 5px rgba(255,0,0, 0.4);
    }
    100% {
        -webkit-box-shadow: 0 0 0 2px rgba(255,0,0, 0.2);
    }
  }
  @keyframes pulse-red {
    0% {
      -moz-box-shadow: 0 0 0 2px rgba(255,0,0, 0.8);
      box-shadow: 0 0 0 2px rgba(255,0,0, 0.8);
    }
    50% {
        -moz-box-shadow: 0 0 0 5px rgba(255,0,0, 0.4);
        box-shadow: 0 0 0 5px rgba(255,0,0, 0.4);
    }
    100% {
        -moz-box-shadow: 0 0 0 2px rgba(255,0,0, 0.2);
        box-shadow: 0 0 0 2px rgba(255,0,0, 0.2);
    }
  }
}

.pulse-green {
  box-shadow: 0 0 0 rgba(0,152,0, 0.4);
  animation: pulse-green 3s infinite;

  @-webkit-keyframes pulse-green {
    0% {
      -webkit-box-shadow: 0 0 0 2px rgba(0,152,0, 0.8);
    }
    50% {
        -webkit-box-shadow: 0 0 0 5px rgba(0,152,0, 0.4);
    }
    100% {
        -webkit-box-shadow: 0 0 0 2px rgba(0,152,0, 0.2);
    }
  }
  @keyframes pulse-green {
    0% {
      -moz-box-shadow: 0 0 0 2px rgba(0,152,0, 0.8);
      box-shadow: 0 0 0 2px rgba(0,152,0, 0.8);
    }
    50% {
        -moz-box-shadow: 0 0 0 5px rgba(0,152,0, 0.4);
        box-shadow: 0 0 0 5px rgba(0,152,0, 0.4);
    }
    100% {
        -moz-box-shadow: 0 0 0 2px rgba(0,152,0, 0.2);
        box-shadow: 0 0 0 2px rgba(0,152,0, 0.2);
    }
  }
}
</style>
